import { ToggleOption } from "./toggle-option";

export class AdditionalDetail{
    sortOrderNumber: number;
    controlType: string;
    key: string;
    label?: string;
    value?: string;
    toggleOptions? : ToggleOption[];
}